module.exports = __webpack_public_path__ + "img/sld_abt_meter_t1_b1_dark.04f1b199.svg";